module.exports = __webpack_public_path__ + "static/media/resume.454b39cf.pdf";